import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSyncroMspPodDataByTicketId } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: number;
}

export const ThunkGetSyncroPodDataByTicketId = createAsyncThunk<IPodData, IProps>(
  'pod/getSyncroMspPodDataByTicketId',
  async ({ psaId, ticketId }) => {
    const r = await getSyncroMspPodDataByTicketId(psaId, ticketId);
    return r.data;
  },
);
